/**
 * Leaderboard API Endpoints
 * Endpoints for adventure leaderboard functionality
 */

import { ApiService } from '../apiService'
import type {
  CompletionTimeLeaderboardResponse,
  UserRankResponse,
  LeaderboardParams,
  UserRankParams,
} from '../types/leaderboard'

export const leaderboardApi = {
  /**
   * Get adventure leaderboard
   * @param adventureId - Adventure ID
   * @param params - Optional query parameters (timeframe, mode, page, pageSize)
   */
  getLeaderboard: (adventureId: string, params?: LeaderboardParams) =>
    ApiService.get<CompletionTimeLeaderboardResponse>(
      `/api/adventures/${adventureId}/leaderboard`,
      params
    ),

  /**
   * Get current user's rank on an adventure leaderboard
   * Requires authentication
   * @param adventureId - Adventure ID
   * @param params - Optional query parameters (mode)
   */
  getMyRank: (adventureId: string, params?: UserRankParams) =>
    ApiService.get<UserRankResponse>(
      `/api/adventures/${adventureId}/leaderboard/my-rank`,
      params
    ),
}
